import React, { useMemo } from 'react'

import { usePrincipal, useProposer } from '../../../authentication'
import { useProduct } from '../../ProductProvider'
import { useProposal } from '../ProposalProvider'
import { AccountSetupPage } from './AccountSetupPage'
import { CheckoutPaths } from './CheckoutPaths'
import { FinalMilePage } from './FinalMilePage'
import { always, hasAddons, hasFinalMile, isNotAuthenticated } from './predicates'
import { ProposalAddOnsPage } from './ProposalAddonsPage'
import { ProposalSummaryPage } from './ProposalSummaryPage'
import { CheckoutConfig } from './types'

const workflow: CheckoutConfig[] = [
  {
    id: 'add-ons',
    path: CheckoutPaths.AddOns,
    element: <ProposalAddOnsPage />,
    predicate: hasAddons,
  },
  {
    id: 'final-mile',
    path: CheckoutPaths.FinalMile,
    element: <FinalMilePage />,
    predicate: hasFinalMile,
  },
  {
    id: 'account-setup',
    path: CheckoutPaths.AccountSetup,
    element: <AccountSetupPage />,
    predicate: isNotAuthenticated,
  },
  {
    id: 'summary',
    path: CheckoutPaths.Summary,
    element: <ProposalSummaryPage />,
    predicate: always,
  },
]

export const useCheckoutConfig = () => {
  const principal = usePrincipal()

  const { proposal } = useProposal()
  const { product } = useProduct()
  const { proposer } = useProposer()

  return useMemo<CheckoutConfig[]>(
    () =>
      workflow.filter(({ predicate }) =>
        predicate({
          proposal,
          principal,
          product,
          proposer,
        }),
      ),
    [proposal, principal, product, proposer],
  )
}
